import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  authService,
  type LoginInput,
  type RegisterInput,
  type AcceptInviteInput,
} from '@/services/api'
import { queryKeys } from '@/config/queryKeys'
import { useAuthStore } from '@/stores/authStore'

export const useCurrentUser = () => {
  return useQuery({
    queryKey: queryKeys.auth.user(),
    queryFn: () => authService.getCurrentUser(),
    retry: false,
  })
}

export const useLogin = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: LoginInput) => authService.login(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.all })
    },
  })
}

export const useRegister = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: RegisterInput) => authService.register(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.all })
    },
  })
}

export const useLogout = () => {
  const queryClient = useQueryClient()
  const clearAuthState = useAuthStore((s) => s.logout)

  return useMutation({
    mutationFn: () => authService.logout(),
    onSuccess: () => {
      clearAuthState()
      queryClient.clear()
    },
  })
}

export const useAcceptInvite = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: AcceptInviteInput) => authService.acceptInvite(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.auth.all })
    },
  })
}
